<template>
  <v-fade-transition>
    <v-snackbar
      class="rounded-snackbar"
      elevation="0"
      :style="alertObject.y === 'top' ? 'top:85px;' : ''"
      v-model="show"
      :color="'transparent'"
      :bottom="alertObject.y === 'bottom'"
      :top="alertObject.y === 'top'"
      :left="alertObject.x === 'left'"
      :right="alertObject.x === 'right'"
      :vertical="alertObject.mode === 'vertical'"
      :timeout="
        alertObject.color === 'error' || alertObject.color === 'cyan'
          ? 0
          : timeout
      "
    >
      <v-alert dense min-height="65px" class="py-5" :type="alertObject.color">
        <v-row class="d-flex align-center" :style="rowStyle">
          <v-col
            cols="12"
            :md="
              alertObject.color === 'error' || alertObject.color === 'cyan'
                ? 10
                : 12
            "
            class="d-flex flex-column justify-center justify-md-start"
          >
            <span>
              {{ alertObject.message }}
            </span>

            <component
              v-if="alertObject?.component?.node"
              :is="alertObject.component?.node"
              v-bind="alertObject.component?.props"
              class="mt-2"
            />

            <div
              v-if="showHelpAssistant"
              class="d-flex align-center mt-3 help-assistant-link"
              @click="openHelpAssistant"
            >
              <v-icon color="white" class="mr-2">mdi-robot-happy-outline</v-icon>
              <span class="text-decoration-underline">
                {{ $t('description.askHelpAssistant') }}
              </span>
            </div>
          </v-col>
          <v-col
            v-if="alertObject.color === 'error' || alertObject.color === 'cyan'"
            cols="12"
            md="2"
            class="d-flex justify-center justify-md-end mt-0 mt-sm-0"
          >
            <v-btn
              :style="buttonStyle"
              text
              @click="closeAlert"
              class="full-height"
              >{{ $t('buttons.ok') }}</v-btn
            >
          </v-col>
        </v-row>
      </v-alert>
    </v-snackbar>
  </v-fade-transition>
</template>

<script>
export default {
  props: {
    options: Object,
  },
  data: () => ({
    show: false,
    showHelpAssistant: false,
  }),
  watch: {
    alertObject() {
      this.showHelpAssistant =
        this.alertObject.statusCode === 409 && this.isHelpAssistantReady();
      this.show = true;
    },
  },
  computed: {
    timeout() {
      let _timeout = this.alertObject.message.split(' ').length * 1000 * 0.35;
      return _timeout < 3000 ? 3000 : _timeout;
    },

    computedClass() {
      return `alert ${this.options.type}`;
    },

    alertObject() {
      return this.$store.state.alertObject;
    },

    buttonStyle() {
      let style = {
        borderRadius: '12px',
      };

      switch (this.alertObject.color) {
        case 'error':
          style.backgroundColor = 'darkred';
          style.color = 'white';
          break;
        case 'warning':
          style.backgroundColor = 'darkgoldenrod';
          style.color = 'black';
          break;
        case 'success':
          style.backgroundColor = 'darkgreen';
          style.color = 'white';
          break;
        case 'cyan':
          style.backgroundColor = '#1d2e5b';

          break;
        default:
      }
      return style;
    },

    rowStyle() {
      return {
        flexDirection: this.$vuetify.breakpoint.xs ? 'column' : 'row',
      };
    },
  },
  methods: {
    closeAlert() {
      this.show = false;
    },

    // Dante AI widget is loaded from public/index.html
    isHelpAssistantReady() {
      const widget = window.DanteWidget;
      return (
        !!widget && widget.status === 'ready' && typeof widget.open === 'function'
      );
    },

    openHelpAssistant() {
      if (!this.isHelpAssistantReady()) return;

      const prompt = this.$t('description.helpAssistantPrompt', {
        message: this.alertObject.message,
      });

      window.DanteWidget.open();
      this.sendPromptToDante(prompt);
      this.closeAlert();
    },

    // Dante has no public API for sending a prompt. This mimics the widget's
    // own "dante:send-prompt" message (used by its suggested prompt bubbles),
    // so it may break if Dante changes embed.js.
    sendPromptToDante(text, timeoutMs = 15000) {
      const post = (iframe, origin) => {
        iframe.contentWindow.postMessage(
          { type: 'dante:send-prompt', text },
          origin
        );
      };

      // Panel was already open and ready, the iframe is listening
      const readyIframe = document.querySelector(
        '.dante-panel-wrap--open .dante-panel-iframe--ready'
      );
      if (readyIframe && readyIframe.contentWindow) {
        post(readyIframe, new URL(readyIframe.src).origin);
        return;
      }

      // Otherwise wait for the new panel iframe to report "dante:ready"
      let timer = null;
      const cleanup = () => {
        window.removeEventListener('message', onMessage);
        clearTimeout(timer);
      };
      const onMessage = (e) => {
        if (e.data?.type !== 'dante:ready') return;

        const iframe = Array.from(
          document.querySelectorAll('.dante-panel-iframe')
        ).find((item) => item.contentWindow === e.source);
        if (!iframe) return;

        cleanup();
        post(iframe, e.origin);
      };

      timer = setTimeout(cleanup, timeoutMs);
      window.addEventListener('message', onMessage);
    },
  },
};
</script>

<style>
.rounded-snackbar .v-snack__content {
  min-height: 65px;
}
.rounded-snackbar .v-snack__wrapper {
  border-radius: 12px;
}
.help-assistant-link {
  cursor: pointer;
  font-size: 0.9rem;
}
.full-height {
  height: 100%;
  display: flex;
  align-items: center;
}
</style>
